import React, { useState } from "react";
import PatientTypeForm from '../patienttype-form/PatientTypeForm';
import DimLoader from "../../../../templates/components/DimLoader";
import APIResponse from "../../../../templates/components/APIResponse";
import PatientTypeService from "../../../../../services/api/patient-type.service";

const EditPatientType = (props) => {

    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const submitHandler = (data) => {
        setIsLoader(true)
        let reqObj = { 
            patientType : data.patientType,
            appointmentBorderColor : data.appointmentBorderColor,
            isDefault : data.isDefault || false,
            practicePatientTypeId: data.practicePatientTypeId
        }
        PatientTypeService.editPatientType(reqObj)
            .then(response => {
                setApiResponse(response)
                setIsLoader(false)
            })
            .catch(error => {
                setApiResponse(error)
                setIsLoader(false)
            })
    }
    return (<>
        <div>
            {isLoader &&
                <DimLoader loadMessage="Processing" />
            }
            <PatientTypeForm submitLabel="Update" submitHandler={submitHandler} onClose={() => props.onClose()} initialData={props.initialData || {}} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </div>
    </>);
}

export default EditPatientType;